import config from 'SRC/config/config.yaml'

export const getCannonicalUrl = path => {
  return `https://oglasi.me${path}`
}
